module.exports = __webpack_public_path__ + "media/images/benefits_placeholder-2e371eb410d8d4dcda271e4d687bcfcd.jpg";